/**
 * @file cc-filters.js
 * Filter bar feature module for the Credit Calculator Wizards pages.
 *
 * Responsibilities:
 *  - `submitResultsFilterForm()` — submits the `.results-filter-bar__form` programmatically.
 *  - Filter checkbox change handler — debounces auto-submit (120 ms) when any course,
 *    unit, or status filter checkbox changes.
 *  - `#search-with-filters` click handler — manual trigger for the same submit.
 *  - `closeAllDropdowns()` — collapses all `.filter-dropdown` `<details>` panels,
 *    optionally excluding one.
 *  - Filter `<details>` toggle listener — ensures only one panel is open at a time.
 *  - Outside-click listener — closes all panels when clicking outside a `.filter-dropdown`.
 *  - Escape keydown listener — closes the open panel and returns focus to its `<summary>`.
 */



var $resultsFilterForm = $(".results-filter-bar__form").first();
var filterSubmitTimer;
const filterDropdowns = Array.from(document.querySelectorAll(".filter-dropdown"));

/**
 * Triggers a submit event on the results filter form.
 * No-ops if the form element is not present on the page.
 */
function submitResultsFilterForm() {
    if (!$resultsFilterForm.length) {
        return;
    }
    $resultsFilterForm.trigger("submit");
}

if ($resultsFilterForm.length) {
    $resultsFilterForm.on(
        "change",
        'input[type="checkbox"][name="course-filter[]"], input[type="checkbox"][name="unit-filter[]"], input[type="checkbox"][name="status-filter[]"]',
        function () {
            clearTimeout(filterSubmitTimer);
            filterSubmitTimer = setTimeout(submitResultsFilterForm, 120);
        },
    );

    $resultsFilterForm.on("click", "#search-with-filters", function (e) {
        e.preventDefault();
        submitResultsFilterForm();
    });
}

if (filterDropdowns.length) {
    /**
     * Removes the `open` attribute from every `.filter-dropdown` `<details>` element,
     * optionally skipping one (used so the just-opened panel stays visible).
     *
     * @param {HTMLElement|null} [except=null] A dropdown element to leave open.
     */
    function closeAllDropdowns(except = null) {
        filterDropdowns.forEach(function (dropdown) {
            if (dropdown !== except) {
                dropdown.removeAttribute("open");
            }
        });
    }

    filterDropdowns.forEach(function (dropdown) {
        dropdown.addEventListener("toggle", function () {
            if (dropdown.open) {
                closeAllDropdowns(dropdown);
            }
        });
    });

    document.addEventListener("click", function (event) {
        if (!event.target.closest(".filter-dropdown")) {
            closeAllDropdowns();
        }
    });

    document.addEventListener("keydown", function (event) {
        if (event.key !== "Escape") {
            return;
        }

        const openDropdown = document.querySelector(".filter-dropdown[open]");
        if (!openDropdown) {
            return;
        }

        const summary = openDropdown.querySelector("summary");
        openDropdown.removeAttribute("open");

        if (summary) {
            summary.focus();
        }
    });
}
